import { useSelector } from 'react-redux'
import { selectDetailMenuSite } from '@/redux/meta/selector'
import { selectSectionSettingData } from '@/redux/customisation/selector'
import { isEmpty } from '@/utils/string'

const useGetMenuLogo = () => {
  const detailMenuSite = useSelector(selectDetailMenuSite)
  const sectionSettingData = useSelector(selectSectionSettingData)

  const { settings: customisationSettings = {} } =
    sectionSettingData?.sections?.['header'] || {}

  const {
    showLogo,
    logoImage,
    storeName,
    showStoreName = true,
    navigationLinkFontColor,
    storeNameFontType,
  } = customisationSettings

  const name = !isEmpty(storeName)
    ? storeName
    : !isEmpty(detailMenuSite?.menu?.name)
      ? detailMenuSite?.menu?.name
      : detailMenuSite?.menu?.name

  return {
    logoImage:
      logoImage ||
      (!isEmpty(detailMenuSite?.logoImage)
        ? `${detailMenuSite?.imagePath}logo/${detailMenuSite?.logoImage}.jpg`
        : ''),
    showLogo: showLogo,
    showStoreName: showStoreName,
    storeName: name,
    font: storeNameFontType,
    textColor: navigationLinkFontColor,
  }
}

export default useGetMenuLogo
